import styled from 'styled-components';

import Link from '~/src/common/components/Link';
import { SPECIALS } from '~/src/common/theme';

export const Container = styled(Link)`
  position: relative;
  display: block;
  padding: 0;
  margin: 0;

  box-shadow: ${SPECIALS.SHADOW_NORMAL};
  border-radius: 4px;

  svg {
    position: absolute;
    padding: 4px;
    inset: 0;

    display: block;
    width: 100%;
    height: 100%;

    shape-rendering: crispedges;
    transition: opacity 0.2s ease;
    opacity: 0;
  }

  &[aria-busy='false'] svg {
    opacity: 1;
  }
`;
